class ProductCarousel extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    this.initSlider()
  }

  initSlider() {
    this.sliderElement = new Swiper(this.querySelector(".js-slider"), {
      slidesPerView: 1.3,
      slidesOffsetBefore: 14,
      slidesOffsetAfter: 14,
      spaceBetween: 16,
      breakpoints: {
        990: {
          slidesPerView: 4,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0,
          spaceBetween: 23
        },
      },
    })
  }
}

customElements.define("product-carousel", ProductCarousel)
